<ion-list lines="none">
  <ion-radio-group [value]="selectedSlot || 'now'" (ionChange)="handleRadioChange($event)" [compareWith]="compareSlots">
    <ion-item>
      <ion-radio value="now" class="drr-radio-circle">
        <aaa-text size="footnote" color="text" i18n>Request Assistance Now</aaa-text>
      </ion-radio>
    </ion-item>
    @for (slot of appointmentSlots; track slot.startTime) {
      <ion-item>
        <ion-radio [value]="slot" class="drr-radio-circle">
          <aaa-text size="footnote" color="text">{{slot.startTime | date:'h:mm a'}} - {{slot.endTime | date:'h:mm a'}}</aaa-text>
        </ion-radio>
      </ion-item>
    }
  </ion-radio-group>
</ion-list>
